import axios from "axios";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { serverURL } from "../components/networking";

export default function Upload() {
    const [uploaded, setUploaded] = useState(false);
    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [lat, setLat] = useState("");
    const [long, setLong] = useState("");
    const [notes, setNotes] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    return (
        <div>
            {uploaded ? (
                <CompletionPage setUploaded={setUploaded} />
            ) : (
                <div className="upload-container">
                    <h1 className="section-title">Upload New Forest Data</h1>
                    <p>Dataset Name</p>{" "}
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <p>Time Collected</p>{" "}
                    <input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />{" "}
                    <input
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                    />
                    <p>Description (optional)</p>{" "}
                    <input
                        type="text"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                    <br />
                    <p>Latitude</p>{" "}
                    <input
                        type="number"
                        value={lat}
                        onChange={(e) => setLat(e.target.value)}
                    />
                    <p>Longitude</p>{" "}
                    <input
                        type="number"
                        value={long}
                        onChange={(e) => setLong(e.target.value)}
                    />
                    {/* <button type="button">Choose Location on Map (optional)</button> */}
                    <FileUploader
                        setUploaded={setUploaded}
                        name={name}
                        date={date}
                        time={time}
                        lat={lat}
                        long={long}
                        notes={notes}
                        setErrorMessage={setErrorMessage}
                        setLoading={setLoading}
                    />
                    <h5 className="error-message">{errorMessage}</h5>
                </div>
            )}
            {loading ? <h5>Loading</h5> : <></>}
        </div>
    );
}

function FileUploader({
    setUploaded,
    name,
    date,
    time,
    lat,
    long,
    notes,
    setErrorMessage,
    setLoading,
}) {
    var file;
    let plot_id = uuidv4();
    function submit() {
        if (name && date && lat && long && file) {
            setErrorMessage("");
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            const formData = new FormData();
            const plotData = {
                date_collected: time == "" ? date : date + "T" + time,
                plot_id: plot_id,
                name: name,
                center_latitude: Number(lat),
                center_longitude: Number(long),
                notes: notes,
            };
            formData.append("lidarFile", file);
            formData.append("data", JSON.stringify(plotData));
            axios
                .post(serverURL + "/api/web/plot/", formData, {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                })
                .then(function (response) {
                    setErrorMessage("");
                    setLoading(false);
                })
                .catch(function (error) {
                    setErrorMessage(error.response.data.message);
                    setLoading(false);
                });

            setUploaded(true);
        } else {
            setErrorMessage("Please fill out all required fields.");
        }
    }

    return (
        <div className="file-uploader">
            <p>Choose File(s)</p>
            <input type="file" onChange={(e) => (file = e.target.files[0])} />
            <button type="button" onClick={submit}>
                Submit
            </button>
        </div>
    );
}

function CompletionPage({ setUploaded }) {
    return (
        <div className="completion">
            <h1>Your data has been uploaded</h1>
            <h3>
                Your data has reached the server and is currently being
                processed.
                <br /> This can take anywhere from a few minutes to a few hours
                depending on the size of the dataset; You will receive an email
                when the report is ready to be viewed.
            </h3>
            <button onClick={() => setUploaded(false)}>
                Return to Upload Page
            </button>
        </div>
    );
}
